export default __webpack_public_path__ + "static/media/mo_premium_01.b599e8f5.jpg";